import type { FileRouteTypes } from '@client/routeTree.gen';
import { useCallback } from 'react';
import { useGetRouteMatches } from './useGetRouteMatches';
import type { useGetRouteStaticData } from './useGetRouteStaticData';

/**
 * Merges the `staticData` of every route matched by a path, parent → child.
 *
 * The merge is a SHALLOW spread: a child key replaces the parent's wholesale. A child that
 * declares `permissions` (or `modules`, `roles`, …) replaces the parent's list rather than
 * combining with it — access checks in `useHasRouteAccess` rely on this.
 */
export function useGetRouteMetadata() {
    const getRouteMatches = useGetRouteMatches();

    return useCallback(
        (path: FileRouteTypes['to']) =>
            getRouteMatches(path).reduce(
                (prev, item) => ({ ...prev, ...item.staticData }),
                {} as ReturnType<ReturnType<typeof useGetRouteStaticData>>,
            ),
        [getRouteMatches],
    );
}
